import { render, staticRenderFns } from "./FullSwiper.vue?vue&type=template&id=a79dc674&scoped=true&"
import script from "./FullSwiper.vue?vue&type=script&lang=js&"
export * from "./FullSwiper.vue?vue&type=script&lang=js&"
import style0 from "./FullSwiper.vue?vue&type=style&index=0&id=a79dc674&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79dc674",
  null
  
)

export default component.exports